import { Fragment, ReactNode, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { makeStyles } from '@material-ui/core';

import { AddFilterButton } from './AddFilterButton';
import { FilterSearch } from './FilterSearch';
import { FILTER_CONTEXT } from './provider';

const useStyles = makeStyles(theme => ({
  topContainer: {
    display: 'flex',
    maxWidth: '275px',
    gap: 'var(--bui-space-2)',
    alignItems: 'center',
    gridRow: 2,
    gridColumn: '1 / -1',
    [theme.breakpoints.up('sm')]: {
      gridRow: 1,
      gridColumn: 'auto',
    },
  },
  chipContainer: {
    display: 'flex',
    width: '100%',
    gap: 'var(--bui-space-2)',
    paddingTop: 'var(--bui-space-4)',
    paddingBottom: 'var(--bui-space-2)',
    gridRow: 3,
    gridColumn: '1 / -1',
    [theme.breakpoints.up('sm')]: {
      gridRow: 2,
    },
  },
}));

interface FilterControlsProps {
  searchCollapsed?: boolean;
  hideSearch?: boolean;
  debounceTime?: number;
}

export const FilterControls = ({
  searchCollapsed = false,
  hideSearch = false,
  debounceTime = 300,
}: FilterControlsProps) => (
  <>
    {!hideSearch && (
      <FilterSearch
        searchCollapsed={searchCollapsed}
        debounceTime={debounceTime}
      />
    )}
    <AddFilterButton />
  </>
);

export const FilterBar = ({ children }: { children?: ReactNode }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.topContainer}>
        <FilterControls />
        {children}
      </div>
      <ActiveFilters />
    </Fragment>
  );
};

export function ActiveFilters() {
  const classes = useStyles();
  const context = useContext(FILTER_CONTEXT);

  if (!context)
    throw new Error('ActiveFilters must be used within a FiltersProvider');

  const { activeFilters, removeFilter, addFilter } = context;

  if (activeFilters.length === 0) return null;

  return (
    <div className={classes.chipContainer}>
      {activeFilters.map(activeFilter => (
        <Fragment key={`filter-${activeFilter.id}`}>
          {activeFilter.renderViewer({
            onValueChange: newValue => addFilter(activeFilter, newValue),
            onRemove: () => removeFilter(activeFilter.id),
          })}
        </Fragment>
      ))}
    </div>
  );
}
